import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { DateRangePicker } from 'react-date-range';
import { fr } from 'date-fns/locale';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import styled from 'styled-components';
import { customInputRanges, staticRangesCustom } from './datePickerCustom';
import { commandsReport } from '../exportCommandsActions';
import ExportOptions from './ExportOptions';

const CustomPaper = styled(Paper)``;
/**
 * Création d'un fichier d'export de commande
 * @param {function} dispatchCommandsReport Récupération du fichier de commande exporté
 */
const CommandsReports = ({ dispatchCommandsReport }) => {
  const [values, setValues] = useState({
    sentByMe: '0',
    format: 'excel',
    filterBy: 'byCreation'
  });

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection'
  });
  /**
   * Function permettant de modifier les paramêtres d'export
   * @param  {object} event event
   */
  const handleChange = (value, name) => {
    setValues(oldValues => ({
      ...oldValues,
      [name]: value
    }));
  };

  /**
   * Function permettant de modifier le créneau d'export
   * @param  {object} date object avec les date de debut et de fin d'export
   */
  const handleDateSelection = date => {
    setSelectionRange(date.selection);
  };

  /**
   * Création de l'objet data permettant de
   * récupéré le fichier d'export
   */
  const handleClick = () => {
    let data;
    const createdDateFrom = moment(selectionRange.startDate).format(
      'YYYY-MM-DD'
    );
    const createdDateTo = moment(selectionRange.endDate).format('YYYY-MM-DD');
    const { sentByMe, format } = values;

    switch (values.filterBy) {
      case 'byCreation':
        data = {
          createdDateFrom,
          createdDateTo,
          sentByMe: +sentByMe,
          format
        };
        break;
      case 'byExpedition':
        data = {
          shippedDateFrom: createdDateFrom,
          shippedDateTo: createdDateTo,
          sentByMe: +sentByMe,
          format
        };
        break;
      default:
    }
    dispatchCommandsReport(data);
  };

  return (
    <Grid container direction="row" spacing={4}>
      <Grid item md={3}>
        <ExportOptions
          handleClick={handleClick}
          handleChange={handleChange}
          values={values}
        />
      </Grid>
      <Grid item md={9}>
        <CustomPaper>
          <DateRangePicker
            moveRangeOnFirstSelection={false}
            onChange={handleDateSelection}
            ranges={[selectionRange]}
            locale={fr}
            months={2}
            maxDate={new Date()}
            minDate={new Date('January 01, 2016')}
            direction="horizontal"
            staticRanges={staticRangesCustom}
            inputRanges={customInputRanges}
          />
        </CustomPaper>
      </Grid>
    </Grid>
  );
};

CommandsReports.propTypes = {
  dispatchCommandsReport: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  dispatchCommandsReport: data => dispatch(commandsReport(data))
});

export default connect(null, mapDispatchToProps)(CommandsReports);
